import * as AssetDir from '../AssetDir/AssetDir.js'

export const ArrowDown = `${AssetDir.assetDir}/icons/arrow-down.svg`
export const ArrowLeft = `${AssetDir.assetDir}/icons/arrow-left.svg`
export const ArrowRight = `${AssetDir.assetDir}/icons/arrow-right.svg`
export const ArrowUp = `${AssetDir.assetDir}/icons/arrow-up.svg`
export const CaseSensitive = `${AssetDir.assetDir}/icons/case-sensitive.svg`
export const ChevronDown = `${AssetDir.assetDir}/icons/chevron-down.svg`
export const ChevronUp = `${AssetDir.assetDir}/icons/chevron-up.svg`
export const ChevronRight = `${AssetDir.assetDir}/icons/chevron-right.svg`
export const Close = `${AssetDir.assetDir}/icons/close.svg`
export const DebugContinue = `${AssetDir.assetDir}/icons/debug-continue.svg`
export const DebugPause = `${AssetDir.assetDir}/icons/debug-pause.svg`
export const DebugStepInto = `${AssetDir.assetDir}/icons/debug-step-into.svg`
export const DebugStepOut = `${AssetDir.assetDir}/icons/debug-step-out.svg`
export const DebugStepOver = `${AssetDir.assetDir}/icons/debug-step-over.svg`
export const ExtensionDefaultIcon = `${AssetDir.assetDir}/icons/extensionDefaultIcon.png`
export const LinkExternal = `${AssetDir.assetDir}/icons/link-external.svg`
export const NextMatch = `${AssetDir.assetDir}/icons/arrow-down.svg`
export const PreviousMatch = `${AssetDir.assetDir}/icons/arrow-up.svg`
export const Refresh = `${AssetDir.assetDir}/icons/refresh.svg`
export const Regex = `${AssetDir.assetDir}/icons/regex.svg`
export const ReplaceAll = `${AssetDir.assetDir}/icons/replace-all.svg`
export const TriangleDown = `${AssetDir.assetDir}/icons/triangle-down.svg`
export const TriangleRight = `${AssetDir.assetDir}/icons/triangle-right.svg`
export const WholeWord = `${AssetDir.assetDir}/icons/whole-word.svg`
export const ZoomIn = `${AssetDir.assetDir}/icons/zoom-in.svg`
export const ZoomOut = `${AssetDir.assetDir}/icons/zoom-out.svg`
